import * as React from 'react';
import { Button, FormGroup, ControlLabel, Panel, ButtonToolbar, Glyphicon } from 'react-bootstrap';
import { TicketVisibility } from '@nkr/enums/index';
import JoditEditor from '@nkr/components/editor';
import config from '../jodit-editor-config';
import { ITicket, IUser, ISelectItem, IContactForList, ITicketCannedResponse } from '@nkr/models/index';
import MyUploader from '../file-upload';
import { ITicketMessageFile } from '@nkr/models/ticketing/ticket-message-file';

const editorConfig = { ...config, height: '250px' };

interface IProps {
    show: boolean,
    ticket: ITicket,
    user: IUser,
    attachment: ITicketMessageFile,
    toList: IContactForList[],
    cannedResponse: ITicketCannedResponse,
    onShowCannedResponses: () => void,
    onSave: (to: ISelectItem, message: string, visibility: TicketVisibility, files: File[]) => void,
    onCancel: () => void
}

interface IValidation {
    message: boolean
}

interface IState {
    toList: ISelectItem[],
    to: ISelectItem,
    message: string,
    files: File[],
    visibility: TicketVisibility,
    validation: IValidation
}

class Note extends React.Component<IProps, IState> {
    readonly state: IState = {
        toList: [],
        to: { value: this.props.user.email, label: this.props.user.email, email: this.props.user.email },
        message: '',
        files: [],
        visibility: TicketVisibility.Nkr,
        validation: {
            message: true
        }
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.cannedResponse != null) {
            this.setState({
                message: nextProps.cannedResponse.message
            });
        }
    }

    handleToChange = (to: ISelectItem) => {
        this.setState({
            to
        });
    }

    handleMessageChange = (e: any) => {
        this.setState({
            message: e
        });
    }

    handleFilesChanged = (file: File, status: string) => {
        let files = [...this.state.files];

        if (status == 'done') {
            files.push(file);
        }

        if (status == 'removed') {
            files = files.filter(x => x.name != file.name);
        }

        this.setState({
            files
        });
    }

    handleSave = () => {
        let { to, message, visibility, files } = this.state;

        let messageValid = message != '';
        let validation: IValidation = { message: messageValid };

        this.setState({
            validation
        }, () => {
            if (validation.message)
                this.props.onSave(to, message, visibility, files);
        });
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        return (
            <>
                <Panel>
                    <Panel.Body>
                        <FormGroup validationState={this.state.validation.message ? null : 'error'}>
                            <ControlLabel>Note</ControlLabel>
                            <JoditEditor
                                value={this.state.message}
                                config={editorConfig}
                                setFocus={true}
                                onChange={this.handleMessageChange}
                                onBlur={() => null}
                            />

                            {!this.state.validation.message && (
                                <span className='help-block'>Please enter the contents of the note...</span>
                            )}

                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 5 }}>
                                <div>
                                    <Button bsSize='xs' title='Canned Responses' onClick={this.props.onShowCannedResponses}><Glyphicon glyph='comment' /></Button>
                                </div>
                                <div>
                                    <MyUploader filesChanged={this.handleFilesChanged} />
                                </div>
                            </div>
                        </FormGroup>

                        <ButtonToolbar style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button bsStyle='primary' onClick={this.handleSave}>Save Note</Button>
                            <Button onClick={this.handleCancel}>Cancel</Button>
                        </ButtonToolbar>
                    </Panel.Body>
                </Panel>
            </>
        );
    }
}

export default Note;